import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import {
  Button,
  Intent,
  Spinner,
  Icon,
  Popover,
  Menu,
  MenuItem,
} from "@blueprintjs/core";
import DeleteJobModal from "./DeleteJobModal";
import qs from "qs";
import InvoiceJobModal from "components/Job/InvoiceJobModal";
import AddTimeLogModal from "components/Job/AddTimeLogModal";
import Toast from "helpers/toaster";
import { serviceTypeTagStyle } from "helpers/serviceTypeColor";
import _ from "lodash";

@inject(
  "store",
  "jobStore",
  "viewStore",
  "invoiceStore",
  "taxStore",
  "activityStore",
)
@observer
class JobHeader extends Component {
  @observable isOpenAddJobInvoiceDialog = false;
  @observable isDeleteDialogVisible = false;
  @observable isOpenAddTimeLogDialog = false;
  @observable isUploading = false;
  fileInputRef = React.createRef();
  @observable selectedAssignment;
  @observable client_details = {
    attributes: {
      name: "",
    },
  };

  startEditJob() {
    this.props.jobStore.persistJob = {
      object: {
        ...this.props.job.attributes,
        isServiceAgreement: false,
        location: {
          attributes: this.props.job.attributes.location,
        },
        client: {
          attributes: this.props.job.attributes.client,
        },
        selectedServiceType: [
          {
            value: this.props.job.attributes.service_type_id,
            selected: true,
            label: this.props.job.attributes.service_type_name,
          },
        ],
      },
    };
    this.props.store.isOpen = true;
  }

  // The job page's tab bars ("Add time log", "Upload files") use the same
  // actions as the More menu, which live here with their dialogs.
  componentDidMount() {
    if (this.props.registerActions) {
      this.props.registerActions({
        addTimeLog: () => this.handleTimeLogClick(),
        uploadFiles: () => this.fileInputRef.current && this.fileInputRef.current.click(),
      });
    }
  }

  handleOnClose() {
    this.isDeleteDialogVisible = false;
  }

  remindTechs() {
    this.props.jobStore.remindTechs(this.props.job);
  }

  handleTimeLogClick() {
    let {
      jobStore: {
        job: { object },
        timelog,
      },
    } = this.props;
    timelog.object.job_id = object.id;
    this.isOpenAddTimeLogDialog = true;
  }

  handleCloseTimeLogDialog() {
    this.isOpenAddTimeLogDialog = false;
  }

  onSuccessAddTimeLog() {
    let {
      jobStore,
      jobStore: {
        job: { object },
      },
    } = this.props;
    this.isOpenAddTimeLogDialog = false;
    // reloading timesheets
    jobStore.loadJobTimesheets(object);
  }

  handleInvoiceJobClick() {
    let {
      job,
      taxStore,
      viewStore: { currentUser },
      invoiceStore: {
        jobInvoice: { object },
      },
    } = this.props;
    let defaultTax = undefined;
    taxStore.loadTaxes().then((response) => {
      defaultTax = _.find(response.data.data, {
        attributes: { is_default: true },
      });
    });

    //this.props.jobStore.loadJobInvoice(job.attributes.id);

    // client pre selected for work order
    this.client_details.attributes = job.attributes.client;
    object.selectedClient = this.client_details;
    object.client_id = job.attributes.client.id;

    // job pre selected for work order
    let job_detals = [];
    job_detals = [
      {
        id: job.attributes.id,
        label: job.attributes.title,
        value: job.attributes.id,
        selected: true,
      },
    ];
    object.selectedJob = job_detals;
    object.scheduled_event_id = job.attributes.id;

    // location pre selected for work order
    let location_details = {
      attributes: job.attributes.location,
    };
    object.location = location_details;
    object.location_id = job.attributes.location.id;

    object.technician_id = [currentUser.id];
    object.po_number = job.attributes.po_number || '';

    // job search using client id for work order
    this.props.viewStore.jobSearch.where.client_id = job.attributes.client.id;
    this.props.jobStore
      .loadWorkReportLineItems(job.attributes.id)
      .then((response) => {
        if (defaultTax !== undefined) {
          var lineItems = response.data;
          lineItems.line_items.labours.map((labor) => {
            labor.attributes.tax_line_item_id = defaultTax.attributes.id;
            labor.attributes.tax_amount =
              (defaultTax.attributes.percentage_value / 100) *
              labor.attributes.total;
          });
          lineItems.line_items.materials.map((material) => {
            material.attributes.tax_line_item_id = defaultTax.attributes.id;
            material.attributes.tax_amount =
              (defaultTax.attributes.percentage_value / 100) *
              material.attributes.total;
          });
          lineItems.line_items.customs.map((custom) => {
            custom.attributes.tax_line_item_id = defaultTax.attributes.id;
            custom.attributes.tax_amount =
              (defaultTax.attributes.percentage_value / 100) *
              custom.attributes.total;
          });
          this.props.jobStore.materialLineItems.object = lineItems;
        }
      });
    this.isOpenAddJobInvoiceDialog = true;
  }

  onSuccessAddJobInvoice() {
    this.isOpenAddJobInvoiceDialog = false;
  }

  handleCloseJobInvoiceDailog() {
    this.isOpenAddJobInvoiceDialog = false;
  }

  changeJobStatus(status) {
    let { job, jobStore, activityStore } = this.props;
    jobStore
      .changeJobStatus(job, status)
      .then((result) => {
        Toast.show({
          icon: "thumbs-up",
          message:
            status === "invoiced"
              ? "Job successfully marked as Invoiced!"
              : "Job successfully marked as Not Invoiced!",
          intent: Intent.SUCCESS,
        });
        if (result.applied) {
          activityStore.loadActivityLogs(job.attributes.id);
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          Toast.show({
            icon: "warning-sign",
            message: error.response.data.errors,
            intent: Intent.DANGER,
          });
        } else {
          Toast.show({
            icon: "warning-sign",
            message: "Something went wrong. Failed to change job status.",
            intent: Intent.DANGER,
          });
        }
      });
  }

  onChangeFile = (event) => {
    const { jobStore } = this.props;
    const files = event.target.files;
    if (!files || files.length === 0) return;

    for (let i = 0; i < files.length; i++) {
      const fileSizeMB = files[i].size / 1024 / 1024;
      if (fileSizeMB > 20) {
        Toast.show({
          icon: "warning-sign",
          message: `File "${files[i].name}" exceeds 20 MB!`,
          intent: Intent.DANGER,
        });
        event.target.value = null;
        return;
      }
    }

    this.isUploading = true;
    jobStore
      .uploadAttachments(files)
      .then(() => {
        this.isUploading = false;
        event.target.value = null;
        Toast.show({
          icon: "thumbs-up",
          message: "Files uploaded successfully.",
          intent: Intent.SUCCESS,
        });
      })
      .catch(() => {
        this.isUploading = false;
        event.target.value = null;
        Toast.show({
          icon: "warning-sign",
          message: "Failed to upload files.",
          intent: Intent.DANGER,
        });
      });
  };

  getPriorityMapping(priority) {
    switch ((priority || "").toLowerCase()) {
      case "urgent":
        return {
          emoji: "🔥",
          label: "Urgent",
          background: "#FFEBEE",
          text: "#C62828",
        };
      case "waiting_on_parts":
        return {
          emoji: "🛠️",
          label: "Waiting on Parts",
          background: "#EFEBE9",
          text: "#4E342E",
        };
      case "high":
        return {
          emoji: "⚠️",
          label: "High",
          background: "#FFF3E0",
          text: "#E65100",
        };
      case "medium":
        return {
          emoji: "👀",
          label: "Medium",
          background: "#FFFDE7",
          text: "#F57F17",
        };
      case "normal":
      default:
        return {
          emoji: "💤",
          label: "Low",
          background: "#E1F5FE",
          text: "#01579B",
        };
    }
  }

  render() {
    let {
      job,
      viewStore,
      jobStore: { showMarkAsInvoicedLoader },
    } = this.props;
    const a = job.attributes;
    const priority = this.getPriorityMapping(a.priority);
    const invoiced = a.status === "invoiced";
    const canInvoice = a.counts && a.counts.work_order > 0;
    return (
      <React.Fragment>
        <header className="cp-head jp-head" aria-label="Job">
          <span className="jp-head__icon" aria-hidden="true">
            <Icon icon={a.service_agreement_id ? "repeat" : "calendar"} iconSize={20} />
          </span>
          <div className="cp-head__who">
            <h1 className="cp-head__name">{a.title || `Job #${a.event_number}`}</h1>
            <div className="cp-head__meta">
              <span className="jp-head__number">Job #{a.event_number}</span>
              {a.client_id && (
                <a href={`/dashboard/clients/${a.client_id}/`}>
                  <Icon icon="person" iconSize={13} />
                  {a.client_name}
                </a>
              )}
              {a.created_by_id && (
                <a
                  href={`/dashboard/users/${a.created_by_id}/show?${qs.stringify(viewStore.userShowSearch, { encode: false })}`}
                  title="Created by"
                >
                  <Icon icon="edit" iconSize={13} />
                  Created by {a.created_by_fullname}
                </a>
              )}
            </div>
          </div>
          <div className="jp-head__actions">
            {canInvoice && (
              <Button className="jp-btn" icon="dollar" text="Invoice job" onClick={() => this.handleInvoiceJobClick(this)} />
            )}
            <Button className="jp-btn jp-btn--icon" icon="edit" title="Edit job" aria-label="Edit job" onClick={this.startEditJob.bind(this)} />
            <Popover minimal={true} inheritDarkTheme={false} position="bottom-right">
              <Button className="jp-btn" rightIcon="chevron-down" text="More" />
              <Menu>
                {invoiced ? (
                  <MenuItem text="Mark as not invoiced" icon="dollar" onClick={() => this.changeJobStatus("not-invoiced")} />
                ) : (
                  <MenuItem text="Mark as invoiced" icon="dollar" onClick={() => this.changeJobStatus("invoiced")} />
                )}
                <Menu.Divider />
                <MenuItem text="Add work order" icon="clipboard" onClick={this.props.handleWorkReportClick} />
                <MenuItem text="Add estimate" icon="document" onClick={this.props.handleEstimateClick} />
                <MenuItem text="Add invoice" icon="dollar" onClick={this.props.handleInvoiceClick} />
                <MenuItem
                  text="Add time log"
                  icon="time"
                  disabled={!canInvoice}
                  title={canInvoice ? undefined : "Add a work order first"}
                  onClick={canInvoice ? this.handleTimeLogClick.bind(this) : undefined}
                />
                <MenuItem
                  text={this.isUploading ? "Uploading…" : "Upload files"}
                  icon="paperclip"
                  disabled={this.isUploading}
                  onClick={() => this.fileInputRef.current.click()}
                />
                <Menu.Divider />
                <MenuItem text="Delete job" icon="trash" intent="danger" onClick={() => { this.isDeleteDialogVisible = true; }} />
              </Menu>
            </Popover>
            <input
              ref={this.fileInputRef}
              type="file"
              accept=".jpg,.jpeg,.gif,.png,.pdf,.doc,.docx,.xls,.xlsx,.svg,.md,.txt,.csv,.odt,.ppt,.pptx,.rtf"
              multiple
              style={{ display: "none" }}
              onChange={this.onChangeFile}
            />
            <Button className="jp-btn jp-btn--primary" icon="notifications" text="Remind technicians" onClick={this.remindTechs.bind(this)} />
          </div>
          <div className="jp-head__pills">
            {a.service_type_name && (
              <span className="jp-pill" style={serviceTypeTagStyle(a.service_type_color)}>{a.service_type_name}</span>
            )}
            <span className={`jp-pill ${invoiced ? "jp-pill--green" : "jp-pill--grey"}`}>
              {invoiced ? "Invoiced" : "Not invoiced"}
            </span>
            <span className="jp-pill" style={{ background: priority.background, color: priority.text }}>
              {priority.emoji} {priority.label} priority
            </span>
            {a.service_agreement_id && a.service_agreement && (
              <button
                type="button"
                className="jp-pill jp-pill--link"
                onClick={() => viewStore.serviceAgreementShow({ uuid: a.service_agreement.id }, a.service_agreement.number)}
              >
                <Icon icon="repeat" iconSize={11} /> Agreement {a.service_agreement.number}
              </button>
            )}
            {showMarkAsInvoicedLoader && <Spinner size={16} />}
          </div>
        </header>
        <DeleteJobModal
          isOpen={this.isDeleteDialogVisible}
          job={job}
          onClose={this.handleOnClose.bind(this)}
        />

        <InvoiceJobModal
          isOpen={this.isOpenAddJobInvoiceDialog}
          onClose={this.handleCloseJobInvoiceDailog.bind(this)}
          onSuccess={this.onSuccessAddJobInvoice.bind(this)}
          edit={true}
          job={job}
        />

        <AddTimeLogModal
          isOpen={this.isOpenAddTimeLogDialog}
          onClose={this.handleCloseTimeLogDialog.bind(this)}
          onSuccess={this.onSuccessAddTimeLog.bind(this)}
        />
      </React.Fragment>
    );
  }
}

export default JobHeader;
